export default {"src":"/_next/static/media/disc-wheels.cf0db769.svg","height":382,"width":556,"blurWidth":0,"blurHeight":0};